module.exports = __webpack_public_path__ + "media/images/landing/icon-sherif-arrow-c5495af0e6f6fbb1e886758fb80eeee4.svg";